module.exports = __webpack_public_path__ + "static/media/InteractiveDataVisualization.469bb87f.png";